import React from 'react';
import { Modal } from 'react-bootstrap';

interface WatchMovieProps {
  show: boolean;
  url: string;
  onClose: Function;
}

  const WatchMovie: React.FC<WatchMovieProps> = ({show, url, onClose}) =>{
  return(
    <Modal size="lg" show={show} onHide={() => onClose()} animation={false}>
      <Modal.Header closeButton>
        <Modal.Title>Assistir filme</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <video width="770" height="550" onContextMenu={() => {return false}}
        controls controlsList="nodownload" src={url} style={{outline: '0px'}}
        preload="auto" muted>
            Your browser does not support the video tag.
        </video>
      </Modal.Body>
    </Modal>
  )
}
export default WatchMovie;
